"use strict";

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spreadArray = this && this.__spreadArray || function (to, from) {
  for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) {
    to[j] = from[i];
  }

  return to;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.match = exports.__ = exports.select = exports.not = exports.when = void 0;

var PatternType_1 = require("./PatternType");

Object.defineProperty(exports, "__", {
  enumerable: true,
  get: function get() {
    return PatternType_1.__;
  }
});

var when = function when(predicate) {
  return {
    '@ts-pattern/__patternKind': PatternType_1.PatternType.Guard,
    '@ts-pattern/__when': predicate
  };
};

exports.when = when;

var not = function not(pattern) {
  return {
    '@ts-pattern/__patternKind': PatternType_1.PatternType.Not,
    '@ts-pattern/__pattern': pattern
  };
};

exports.not = not;
var ANONYMOUS_SELECT_KEY = '@ts-pattern/__anonymous-select-key';

function select(key) {
  return key === undefined ? {
    '@ts-pattern/__patternKind': PatternType_1.PatternType.AnonymousSelect
  } : {
    '@ts-pattern/__patternKind': PatternType_1.PatternType.NamedSelect,
    '@ts-pattern/__key': key
  };
}

exports.select = select;
/**
 * #### match
 *
 * Entry point to create a pattern matching expression.
 *
 * It returns a `Match` builder, on which you can chain
 * several `.with(pattern, handler)` clauses.
 */

var match = function match(value) {
  return builder(value, []);
};

exports.match = match;
/**
 * ### builder
 * This is the implementation of our pattern matching, using the
 * builder pattern.
 */

var builder = function builder(value, cases) {
  var run = function run() {
    var entry = cases.find(function (_a) {
      var test = _a.test;
      return test(value);
    });

    if (!entry) {
      var displayedValue = void 0;

      try {
        displayedValue = JSON.stringify(value);
      } catch (e) {
        displayedValue = value;
      }

      throw new Error("Pattern matching error: no pattern matches value " + displayedValue);
    }

    return entry.handler(entry.select(value), value);
  };

  return {
    with: function _with() {
      var args = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }

      var handler = args[args.length - 1];
      var patterns = [];
      var predicates = [];

      for (var i = 0; i < args.length - 1; i++) {
        var arg = args[i];

        if (typeof arg === 'function') {
          predicates.push(arg);
        } else {
          patterns.push(arg);
        }
      }

      var selected = {};

      var doesMatch = function doesMatch(value) {
        return Boolean(patterns.some(function (pattern) {
          return matchPattern(pattern, value, function (key, value) {
            selected[key] = value;
          });
        }) && predicates.every(function (predicate) {
          return predicate(value);
        }));
      };

      return builder(value, cases.concat([{
        test: doesMatch,
        handler: handler,
        select: function select(value) {
          return Object.keys(selected).length ? selected[ANONYMOUS_SELECT_KEY] !== undefined ? selected[ANONYMOUS_SELECT_KEY] : selected : value;
        }
      }]));
    },
    when: function when(predicate, handler) {
      return builder(value, cases.concat([{
        test: predicate,
        handler: handler,
        select: function select(value) {
          return value;
        }
      }]));
    },
    otherwise: function otherwise(handler) {
      return builder(value, cases.concat([{
        test: function test() {
          return true;
        },
        handler: handler,
        select: function select(value) {
          return value;
        }
      }])).run();
    },
    exhaustive: function exhaustive() {
      return run();
    },
    run: run
  };
};

var isObject = function isObject(value) {
  return Boolean(value && typeof value === 'object');
};

var isGuardPattern = function isGuardPattern(x) {
  var pattern = x;
  return pattern && pattern['@ts-pattern/__patternKind'] === PatternType_1.PatternType.Guard && typeof pattern['@ts-pattern/__when'] === 'function';
};

var isNotPattern = function isNotPattern(x) {
  var pattern = x;
  return pattern && pattern['@ts-pattern/__patternKind'] === PatternType_1.PatternType.Not;
};

var isNamedSelectPattern = function isNamedSelectPattern(x) {
  var pattern = x;
  return pattern && pattern['@ts-pattern/__patternKind'] === PatternType_1.PatternType.NamedSelect;
};

var isAnonymousSelectPattern = function isAnonymousSelectPattern(x) {
  var pattern = x;
  return pattern && pattern['@ts-pattern/__patternKind'] === PatternType_1.PatternType.AnonymousSelect;
}; // tells us if the value matches a given pattern.


var matchPattern = function matchPattern(pattern, value, select) {
  if (isObject(pattern)) {
    if (pattern === PatternType_1.__) return true;

    if (isNamedSelectPattern(pattern)) {
      select(pattern['@ts-pattern/__key'], value);
      return true;
    }

    if (isAnonymousSelectPattern(pattern)) {
      select(ANONYMOUS_SELECT_KEY, value);
      return true;
    }

    if (isGuardPattern(pattern)) return Boolean(pattern['@ts-pattern/__when'](value));
    if (isNotPattern(pattern)) return !matchPattern(pattern['@ts-pattern/__pattern'], value, select);
    if (!isObject(value)) return false;

    if (Array.isArray(pattern)) {
      if (!Array.isArray(value)) return false; // List pattern

      if (pattern.length === 1) {
        var selected_1 = {};

        var listSelect_1 = function listSelect_1(key, value) {
          selected_1[key] = (selected_1[key] || []).concat([value]);
        };

        var doesMatch = value.every(function (v) {
          return matchPattern(pattern[0], v, listSelect_1);
        });

        if (doesMatch) {
          Object.keys(selected_1).forEach(function (key) {
            return select(key, selected_1[key]);
          });
        }

        return doesMatch;
      } // Tuple pattern


      return pattern.length === value.length ? pattern.every(function (subPattern, i) {
        return matchPattern(subPattern, value[i], select);
      }) : false;
    }

    if (pattern instanceof Map) {
      if (!(value instanceof Map)) return false;
      return __spreadArray([], __read(pattern.keys())).every(function (key) {
        return matchPattern(pattern.get(key), value.get(key), select);
      });
    }

    if (pattern instanceof Set) {
      if (!(value instanceof Set)) return false;
      if (pattern.size === 0) return value.size === 0;

      if (pattern.size === 1) {
        var _a = __read(__spreadArray([], __read(pattern.values())), 1),
            subPattern = _a[0];

        return Object.values(PatternType_1.__).includes(subPattern) ? matchPattern([subPattern], __spreadArray([], __read(value.values())), select) : value.has(subPattern);
      }

      return __spreadArray([], __read(pattern.values())).every(function (subPattern) {
        return value.has(subPattern);
      });
    }

    return Object.keys(pattern).every(function (k) {
      return matchPattern( // @ts-ignore
      pattern[k], // @ts-ignore
      value[k], select);
    });
  }

  if (typeof pattern === 'string') {
    if (pattern === PatternType_1.__.string) return typeof value === 'string';
    if (pattern === PatternType_1.__.boolean) return typeof value === 'boolean';

    if (pattern === PatternType_1.__.number) {
      return typeof value === 'number' && !Number.isNaN(value);
    }
  }

  return value === pattern;
};